import { Trans, useTranslation } from "react-i18next";
import { styled, css } from "styled-components";
import { Typography } from "components/typography";
import { useDemo } from "contexts/DemoContext";
import { PsychologistProfile } from "../../core/types";
import { Upload } from "./profilephoto/upload";
import { Link } from "./styled";
import { UploadStatus } from "./profilephoto/upload.types";

type ProfilePictureProps = {
  psychologist: Pick<PsychologistProfile, "thumbnail">;
  psychologistValidation: string[];
  onFileAdded: (file: File) => void;
  uploadStatus: UploadStatus;
};

export const ProfilePicture = ({
  psychologistValidation,
  psychologist,
  onFileAdded,
  uploadStatus,
}: ProfilePictureProps) => {
  const { t } = useTranslation();
  const demo = useDemo();

  const getProfileImage = () => {
    const { thumbnail } = psychologist;
    if (!thumbnail) {
      return <NoThumbnail>{t("CHOOSE")}</NoThumbnail>;
    }

    if (demo) {
      return <NoThumbnail>{t("DEMO")}</NoThumbnail>;
    }

    return <Thumbnail src={thumbnail} alt={"Thumbnail"} />;
  };

  return (
    <>
      <Typography
        insensitive
        variant="h3"
        color={
          psychologistValidation.indexOf("thumbnail") !== -1
            ? "ERROR"
            : undefined
        }
        style={{ marginBottom: "10px", marginTop: 0 }}
      >
        {`${t("PROFILE_PICTURE")}*`}
      </Typography>
      <p style={{ margin: "10px 0px" }}>
        <Trans i18nKey="PROFILE_PICTURE_INFO" components={{ a: <Link /> }} />
      </p>
      <Upload
        thumbnail={getProfileImage()}
        onFileAdded={onFileAdded}
        uploadStatus={uploadStatus}
      />
    </>
  );
};

const placeholder = css`
  max-width: 300px;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const Thumbnail = styled.img`
  ${placeholder}
`;

const NoThumbnail = styled.span`
  ${placeholder}
`;
